import { type HTMLAttributes, forwardRef } from 'react';

import classNames from 'classnames';

import styles from './DialogBox.module.scss';

export const DialogBox = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(function DialogBox(
  { className, ...props },
  ref,
) {
  return <div ref={ref} className={classNames(styles.box, className)} {...props} />;
});
